import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { VideoRenderer } from 'core';
import { Modal } from 'features/Modals';
import { useTrackForVirtualBackground } from 'features/VirtualBackground/hooks/useTrackForVirtualBackground';
import { VirtualBackgroundsList } from './components/VirtualBackgroundsList/VirtualBackgroundsList';
import { VirtualBackgroundModalVideo, Wrapper } from './view';

export const VirtualBackgroundModal = observer(() => {
    const { t } = useTranslation();
    const { localVideoTrack } = useTrackForVirtualBackground();

    return (
        <Modal header={t('videoconference_virtual_backgrounds')}>
            <Wrapper>
                <VirtualBackgroundModalVideo>
                    {localVideoTrack ? <VideoRenderer track={localVideoTrack} isLocal /> : null}
                </VirtualBackgroundModalVideo>
                <VirtualBackgroundsList />
            </Wrapper>
        </Modal>
    );
});

VirtualBackgroundModal.displayName = 'VirtualBackgroundModal2';
